import * as VueRouter from 'vue-router'

const routes = [
    {
        path: "/teacher/teacherDashboard",
        component: () => import("../views/teacher/dashboard.vue"),
        meta: {title: "dashboard", layout: "dashboard-layout"},
        name: "teacherDashboard"
    },
    {
        path: "/teacher/classList",
        component: () => import("../views/teacher/courseList.vue"),
        meta: {title: "classes", layout: "dashboard-layout"},
        name: "classList"
    },
    {
        path: "/teacher/newTask",
        component: () => import("../views/teacher/task/newTask.vue"),
        meta: {title: "New Task", layout: "dashboard-layout"},
        name: "newTask"
    },
    {
        path: "/teacher/taskList",
        component: () => import("../views/teacher/task/taskList.vue"),
        meta: {title: "Task List", layout: "dashboard-layout"},
        name: "taskList"
    },
    {
        path: "/teacher/taskDetail",
        component: () => import("../views/teacher/task/taskDetail.vue"),
        meta: {title: "Task Detail", layout: "dashboard-layout"},
        name: "taskDetail"
    },
    {
        path: "/teacher/editTask",
        component: () => import("../views/teacher/task/editTask.vue"),
        meta: {title: "Edit Task", layout: "dashboard-layout"},
        name: "editTask"
    },

    // student
    {
        path: "/student/taskList",
        component: () => import("../views/student/taskList.vue"),
        meta: {title: "Task List", layout: "dashboard-layout"},
        name: "studentTaskList"
    },
    {
        path: "/student/taskDetail",
        component: () => import("../views/student/taskDetail.vue"),
        meta: {title: "Task Detail", layout: "dashboard-layout"},
        name: "studentTaskDetail"
    },
    {
        path: "/student/taskStatistics",
        component: () => import("../views/student/TaskStatistics.vue"),
        meta: {title: "Task Statistics", layout: "dashboard-layout"},
        name: "studentTaskStatistics"
    },
    // user
    {
        path: "/user/login",
        component: () => import("../views/auth/login.vue"),
        meta: {title: "Sign in", layout: "empty-layout"},
        name: "login"
    },
    {
        path: "/",
        component: () => import("../views/auth/login.vue"),
        meta: {title: "Sign in", layout: "empty-layout"},
        name: "login"
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import("../views/NotFound.vue"),
        meta: {title: "404 Not Found", layout: "empty-layout"},
        name: "NotFound"
    },

    // teacher
    {
        path: "/teacher/teacherList",
        component: () => import("../views/teacher/teacherList.vue"),
        meta: {title: "Teachers", layout: "dashboard-layout"},
        name: "teacherList"
    },
]

const router = VueRouter.createRouter({
    history: VueRouter.createWebHashHistory(),
    routes,
})

router.beforeEach(async (to) => {
    if (to.meta.title) { // Check if there is a title
        document.title = to.meta.title;
    }
})

export default router
